/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { BasePlate } from "src/classes/plate/BasePlate/BasePlate";

interface Props {
  plate: BasePlate;
}
export function PlateTitle({ plate }: Props) {
  return (
    <PageTitle isPublic={plate.snapshot.isPublic}>
      {plate.snapshot.title}
      {!plate.snapshot.currentUserIsOwner && <SharedPageOwner>{plate.snapshot.owner.username}</SharedPageOwner>}
    </PageTitle>
  );
}

const PageTitle = styled.span<{ isPublic: boolean }>`
  color: ${({ theme, isPublic }) => (isPublic ? theme.text.default : theme.accent)};
`;
const SharedPageOwner = styled.span`
  margin-left: 10px;
  color: ${({ theme }) => theme.text.subtle};
`;
